__turbopack_context__.v({
  "active": "PramoW_active",
  "control": "PramoW_control",
  "media": "PramoW_media",
  "outgoing": "PramoW_outgoing",
  "playing": "PramoW_playing",
  "signupLink": "PramoW_signupLink",
  "slide": "PramoW_slide",
  "video": "PramoW_video",
});
